import { http } from '@/app/lib/http/client'

export interface SupplierItem {
  id: number
  company_id: number
  name: string
  contact_name: string
  phone: string
  email: string
  rfc: string | null
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export interface SupplierPayload {
  name: string
  contact_name: string
  phone: string
  email: string
  rfc?: string | null
  is_active?: boolean
}

export interface SupplierPaginator {
  current_page: number
  data: SupplierItem[]
  from: number | null
  to: number | null
  per_page: number
  total: number
}

export interface SupplierApiResponse<T> {
  success: boolean
  message: string
  data: T
}

export const supplierService = {
  async getItems(params?: {
    per_page?: number
    search?: string
    page?: number
    is_active?: boolean
    all?: boolean
  }): Promise<SupplierApiResponse<SupplierPaginator | SupplierItem[]>> {
    const response = await http.get('/suppliers', { params })
    return response.data
  },

  async getItem(id: number): Promise<SupplierApiResponse<SupplierItem>> {
    const response = await http.get(`/suppliers/${id}`)
    return response.data
  },

  async createItem(
    payload: SupplierPayload,
  ): Promise<SupplierApiResponse<SupplierItem>> {
    const response = await http.post('/suppliers', payload)
    return response.data
  },

  async updateItem(
    id: number,
    payload: SupplierPayload,
  ): Promise<SupplierApiResponse<SupplierItem>> {
    const response = await http.put(`/suppliers/${id}`, payload)
    return response.data
  },

  async updateStatus(
    id: number,
    isActive: boolean,
  ): Promise<SupplierApiResponse<SupplierItem>> {
    const response = await http.patch(`/suppliers/${id}/status`, {
      is_active: isActive,
    })
    return response.data
  },

  async deleteItem(id: number): Promise<SupplierApiResponse<null>> {
    const response = await http.delete(`/suppliers/${id}`)
    return response.data
  },
}
